/** Fixed design space shared by every live landing platform preview. */
export const PLATFORM_LOOP_DESIGN = { width: 1280, height: 735 } as const

/** Fade-out length before a platform preview restarts its animation cycle. */
export const PLATFORM_LOOP_RESET_FADE_MS = 300
